import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LearningResourceFeeDto } from '../models/learningresourcefeedto';
import { PaginationFeaturesDto } from '../models/paginationfeaturesdto';
import { AppConfigService } from './core/appConfig.service';

@Injectable({
    providedIn: 'root'
})

export class LearningResourceFeeService {

    constructor(private http: HttpClient, private configService:AppConfigService) {
        // Inicializa cualquier propiedad o realiza configuraciones necesarias
    }

    getLearningResourceFees(pageRequest: PaginationFeaturesDto): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', pageRequest.sizePage)
            .set('orderField', pageRequest.orderField)
            .set('order', pageRequest.order);
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/own-learning-resource/listAll?${params}`).pipe(
            map(response => {
                const learningResourceFeeList = response.listOwnLearningResourcesRateDto.map((item: any) => new LearningResourceFeeDto(item));
                const pageDto = response.pageDto; // Mapea directamente el objeto pageDto
                return { learningResourceFeeList, pageDto };
            })
        );
    };

    getLearningResourceFeesByRateModel(pageRequest: PaginationFeaturesDto, code: any): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', pageRequest.sizePage)
            .set('orderField', pageRequest.orderField)
            .set('order', pageRequest.order);
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/own-learning-resource/listAll?${params}&codeModel=${code}`).pipe(
            map(response => { return response; }));
    }

    getLearningResourceFeeById(idOwnLearningFee: number): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/own-learning-resource/filter/${idOwnLearningFee}`;
        return this.http.get<any>(url).pipe(
            map(response => {
                return new LearningResourceFeeDto(response);
            })
        );
    }

    insertLearningResourceFee(learningResourceFee: LearningResourceFeeDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/own-learning-resource/insert`;
        return this.http.post<any>(url, learningResourceFee).pipe(
            map(response => {
                return new LearningResourceFeeDto(response);
            })
        );
    }

    updateLearningResourceFee(isModif: boolean, learningResourceFee: LearningResourceFeeDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/own-learning-resource/update/${isModif}`;
        return this.http.put<any>(url, learningResourceFee).pipe(
            map(response => {
                return new LearningResourceFeeDto(response);
            })
        );
    }

    cloneLearningResourceFee(idOwnLearningFee: number): Observable<LearningResourceFeeDto> {
        const url = `${this.configService.apiUrl}/configuration/own-learning-resource/price-detail/duplicate/${idOwnLearningFee}`;
        return this.http.post<any>(url, LearningResourceFeeDto).pipe(map(response => { return response; }));
    }

}